import { render, staticRenderFns } from "./PersonalDataModal.vue?vue&type=template&id=5b4849ec&scoped=true&"
import script from "./PersonalDataModal.vue?vue&type=script&lang=js&"
export * from "./PersonalDataModal.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataModal.vue?vue&type=style&index=0&id=5b4849ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4849ec",
  null
  
)

export default component.exports